export function HouseIcon() {
  return (
    <svg
      className="omni-image"
      preserveAspectRatio="xMidYMid meet"
      viewBox="38 43 124.236 113.822"
      height="120"
      width="120"
      role="presentation"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style>{`
          #comp-jzmhemwf svg [data-color='1'] { fill: #A68E68; }
          #comp-jzmhemwf svg [data-color='2'] { fill: #EAEAD9; }
        `}</style>
      </defs>

      <g fillRule="evenodd">
        <path
          fill="#B87E58"
          d="M43.208 90.118v65.402H38V87.958L83.035 43l3.68 3.686-43.507 43.432z"
          data-color="1"
        />
        <path
          fill="#B87E58"
          d="M157.028 90.118v65.402h5.208V87.958L117.201 43l-3.68 3.686 43.507 43.432z"
          data-color="1"
        />
        <path
          fill="#EAEAD9"
          d="M118.729 138.593c0 10.068-8.161 18.229-18.229 18.229s-18.229-8.161-18.229-18.229 8.161-18.229 18.229-18.229 18.229 8.161 18.229 18.229z"
          data-color="2"
        />
      </g>
    </svg>
  );
}